import type { NFT } from "@stepfinance/nft";

interface NFTFileDisplayProps {
  className?: string;
  nft: NFT;
  onImageClick?(e: React.MouseEvent<HTMLElement, MouseEvent>, nft: NFT): void;
}

export const NFTFileDisplay: React.FC<NFTFileDisplayProps> = ({ className, nft, onImageClick = () => {} }) => {
  const image = nft.json?.image;

  return (
    <img
      src={image}
      className={`${className} upper-corners-rounded lower-corners-rounded`}
      data-image={image}
      alt={nft.name}
      onClick={(e) => onImageClick(e, nft)}
    />
  );
};
